// ============================================================================
// LINGALA TRANSLATIONS - UI (Lingala - RC)
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'rc',
    languageName: 'Lingala',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST Makambu\nya Bolingo",
    subtitle: "Koyekola Makomi ya Nzambe na interactive",
    tagline: "Kotambola na pole ya Nzambe",
    menu: "Menu",
    retry: "Meka lisusu"
  },
  
  buttons: {
    play: "KOBANDA",
    back: "Kozonga",
    continue: "Kokoba",
    restart: "Kobanda lisusu",
    close: "Kokanga",
    nextLevel: "Eteni oyo elandaka",
    selectLevel: "Kopona Eteni",
    retry: "Komeka lisusu",
    mainMenu: "Menu ya Liboso",
    start: "Kobanda",
    cancel: "Kotika",
    confirm: "Kondima",
    save: "Kobomba",
    load: "Kozwa",
    yesRestart: "Iyo, bandela",
    noContinue: "Te, koba",
    tryAgain: "Meka lisusu",
    backToMenu: "Zonga na menu"
  },
  
  labels: {
    score: "Mitindo",
    stars: "Minzoto",
    wisdom: "Bwanya",
    revelation: "Komonisama",
    lives: "Bomoi",
    combo: "Combo",
    level: "ETENI",
    easy: "PETE",
    medium: "KATIKATI",
    hard: "MAKASI",
    correct: "Malamu!",
    gameOver: "Komeka ekweyi",
    victory: "Elonga!",
    completed: "Esilami",
    rank: "Esika ya Molimo",
    points: "Bapwana ya Bwanya",
    unlockedLevels: "biteni efungwami",
    questionOfKnowledge: "Motuna ya boyebi",
    hintOfWisdom: "Litalatala ya bwanya",
    knowledgeMastered: "Boyebi eyekoli!",
    knowledgeAcquired: "Boyebi ezwami!",
    testFailed: "Komeka ekweyi",
    wisdomBonus: "Lifuti",
    xpGained: "XP",
    newRank: "Esika ya sika",
    nextGrade: "Ndenge oyo elandi",
    maxLevelReached: "Eteni ya likolo ekomi!",
    wrongAnswer: "Eyano ezali malamu te!"
  },
  
  menu: {
    playButton: "KOBANDA",
    info: "Sango",
    treasures: "Bomengo",
    john: "Yoane",
    reset: "Kozongisa",
    resetConfirm: "Kobanda mobembo lisusu?",
    resetWarning: "Olingi mpenza kolongola nionso oyo osalaki?",
    resetLose: "Okobungisa:",
    wisdomPoints: "Bapwana ya Bwanya",
    starsCollected: "minzoto oyo osangisaki",
    levelsUnlocked: "biteni oyo efungwami",
    spiritualRank: "Rang ya Molimo",
    yesRestart: "Iyo, kobanda lisusu",
    noContinue: "Te, kokoba",
    newAdventure: "Mobembo ya Sika",
    readyToStart: "Omibongisi mpo na kobanda?",
    startJourney: "Bandá mobembo na yo na boyebi ya Makomi ya Nzambe!",
    audioControls: "Ba contrôles ya mongongo",
    mute: "Kokanga mongongo",
    unmute: "Kofungola mongongo",
    close: "Kokanga",
    language: "Lokota",
    restartGame: "Kobanda masano lisusu"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "Mobembo ya Bible ya interactive",
    anonymousMode: "Kobanga na nkombo te",
    anonymousDesc: "Pona nkombo moko",
    emailMode: "Kokota na Email",
    emailDesc: "Kobomba na ba-appareil mingi",
    pseudo: "Nkombo",
    pseudoPlaceholder: "Nkombo na yo...",
    email: "Adresse Email",
    emailPlaceholder: "email@na.yo",
    startPlaying: "Kobanda kosakana",
    sendLink: "Kotinda lien",
    sending: "Kotinda...",
    connecting: "Kokangama...",
    back: "Kozonga",
    localSave: "Oyo osalaki ekobombama awa",
    cloudSync: "Motó te • Synchronisation na cloud",
    magicLink: "Zwa lien ya magie na email",
    checkEmail: "✉️ Talá email na yo! Lien ya kokota etindami.",
    checkSpam: "Talá mpe na dossier ya spam",
    waitingConnection: "Kozela connexion...",
    errorSend: "Libunga ya kotinda lien",
    rateLimited: "⏳ Talela mikolo 15 liboso ya kotinda lisusu email",
    importSession: "🔄 Kokɔtisa molɔngɔ́ uta na production",
    errorConnection: "Libunga ya connexion",
    enterPseudo: "Palado kotya nkombo",
    enterEmail: "Palado kotya email ya malamu",
    // Tooltips
    never: "Ata moke te",
    save: "Kobomba jeu",
    lastSave: "ya suka",
    refresh: "Kotia lisusu bokende liboso",
    logout: "Kobima",
    connectToCloud: "Kokangama pona kobomba na Internet",
    editPseudo: "Kobongola nkombo ya mosaleli",
    confirm: "Kondima",
    cancel: "Kotika",
    close: "Kokanga",
    passwordMode: "Connexion simple",
    passwordDesc: "Email + mot de passe",
    password: "Mot de passe",
    passwordPlaceholder: "Minimum 6 caractères",
    passwordMinLength: "Minimum 6 caractères",
    playWithoutAccount: "Jouer sans compte",
    forgotPassword: "Obosani ndimbo ya kobɔta?",
    resetPasswordTitle: "Réinitialiser le mot de passe",
    resetPasswordSubtitle: "Entrez votre email pour recevoir un lien de réinitialisation",
    sendResetLink: "Envoyer le lien",
    resetEmailSent: "📧 Email de réinitialisation envoyé ! Vérifiez votre boîte mail.",
    errorReset: "Erreur lors de l'envoi de l'email",
    backToSignin: "Retour à la connexion",
    newPassword: "Nouveau mot de passe",
    enterNewPassword: "Choisissez un nouveau mot de passe sécurisé",
    confirmPassword: "Confirmer le mot de passe",
    updatePassword: "Mettre à jour le mot de passe",
    passwordsDontMatch: "Les mots de passe ne correspondent pas",
    passwordUpdateSuccess: "✅ Mot de passe mis à jour avec succès !",
    errorUpdatePassword: "Erreur lors de la mise à jour du mot de passe",
    resetLinkExpired: "Lien de réinitialisation expiré ou invalide",
    forgotPassword: "Obosani ndimbo ya kobɔta?",
    signup: "Inscription",
    signin: "Connexion",
    createAccount: "Créer un compte",
    signupInfo: "Remplissez le formulaire ci-dessous",
    passwordInfo: "Accès rapide avec mot de passe",
    signupButton: "Créer mon compte",
    signinButton: "Se connecter",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
    emailAlreadyExists: "Cet email est déjà utilisé",
    emailExistsHint: "✉️ Cet email est déjà enregistré. Essayez de vous connecter ! (Peut-être créé depuis un autre jeu?)",
    switchToSignin: "🔑 Passez en mode Connexion avec votre email existant",
    invalidCredentials: "Email ou mot de passe incorrect",
    signupSuccess: "📧 Compte esalemi! Talela email na yo pona kondima inscription na yo.",
    emailConfirmationRequired: "Talela boîte na yo ya email pona ko-activer compte na yo",
    checkSpamFolder: "Kanisa ko-talela dossier na yo ya spam",
    connectionSuccess: "✅ Connexion réussie !",
    errorSignup: "Erreur lors de l'inscription"},
  
  install: {
    title: "Tyá aplikasyo",
    subtitle: "Kokóta nokinoki mpé offline",
    feature1: "Kobanda mbala moko na écran ya mboka",
    feature2: "Esalaka offline nsima ya installation",
    feature3: "Expérience ya aplikasyo ya mboka",
    feature4: "Esɛngaka té kokita na magazini",
    install: "Tyá",
    dismiss: "Na nsima",
    info: "Okokoka kolongola aplikasyo ntango nyonso"
  },
  
  ranks: {
    seeker: "Moluki",
    believer: "Oyo alamuki",
    disciple: "Moyekoli",
    servant: "Mosaleli",
    witness: "Mtatoli",
    guardian: "Mokengeli",
    wise: "Moto ya Bwanya",
    prophet: "Profeta",
    apostle: "Ntoma",
    seekerDesc: "Ebandeli ya mobembo ya molimo",
    believerDesc: "Boyebi ya molimo elamuki",
    discipleDesc: "Koyekola mateya",
    servantDesc: "Mosala mpe kotya motema",
    witnessDesc: "Kokabola kondima",
    guardianDesc: "Kobatela bosolo",
    wiseDesc: "Bwanya mpe boyebi",
    prophetDesc: "Emoniseli ya molimo",
    apostleDesc: "Molakisi ya molimo"
  },

  spiritualJourney: {
    beginning: "Ebandeli ya mobembo ya molimo",
    progress: "Bokoli ya molimo",
    grade: "Likolo",
    xp: "XP",
    level: "Eteni",
    nextGrade: "Likolo oyo ekoya",
    still: "Naino",
    maxLevelReached: "Eteni ya suka ekomami!",
    masteredAllTeachings: "Oyekoli mateya nyonso",
    progression: "Bokoli"
  },
  
  treasures: {
    title: "💎 Bomengo ya Bible",
    verse: "Liloba ya lelo",
    fact: "Oyebaki?",
    treasure: "Bomengo ya kobombama",
    question: "Motuna ya koseka",
    context: "Contexte",
    strongReference: "Référence biblique pona boyekoli ya mozindo",
    verseOfDay: "✨ Liloba ya lelo",
    didYouKnow: "🌟 Oyebaki?",
    hiddenTreasure: "📜 Bomengo ya kobombama",
    funnyQuestion: "🤔 Motuna ya koseka",
    emmanuelMemo: "Mokanda ya Emmanuel",
    emmanuelMessage: "Okokomi na songe ya ngomba, mpe boyebi ezwami. Kasi kondima oyo ekoki koningana te esengaka mayele ya bomoi, mawa mpe bolingo ya solo ya Yesu. Bapasi ndenge na ndenge ya bomoi ekomeka nzela na yo, nzela ya solo oyo toponaka, motema na biso. Tozali kokoka te, bamposa na biso ezali mingi, mpe bolingo ya lifuti to ya kobika malamu na biso ekomaka mbala mingi likambo ya liboso ya biso ya komitya. Senga na Nzambe bwanya, bolingo na ye, makasi na ye, mpe yamba na komikitisa makasi na yo, mpo eloko moko te ekoki kobombama na ye... Eloko moko te. Esengeli te kotambola na mode privé, kosalela VPN to kutu kolongola histoire. Kilá ndenge Daniel: Omiboya ntango moke na oyo olingaka mingi, na kimia mpe bwanya. Yango ekopesa yo nzela ya koyoka Nzambe malamu, kozala na ekateli ya motema oyo ebongisami mpo na mbongwana ya mozindo - mpe mbala mingi ya mpasi. Na nsima, bandoto mpe bimoniseli ekokóma polele mingi, lokola Yosefu. Kasi keba na lofundu: Komipesa te na 'Nazali ntango nyonso na reto' to 'Nayebi malamu'. Mpo emoniseli ya Nzambe ezali ngolu ya kokamwa. Kokóma te moteyi ya Mobeko, oyo akoki kobaka Yesu lisusu lelo, Ye oyo asengaka kaka kolinga moninga na yo... mpe kopesa ye bonsomi ndenge moko ozwi. Kozala na kondima elingi koloba kokota na boyokani ya bonsomi mpe mobembo ya motema. Ekosala bino banganga ya nguya, oyo bakoki kosala makambo ya kokamwa. Mpo mayele ya surnaturel, bozali ya Nzambe, bondimi to mapamboli na ye ekosala bino makasi mpenza.",
    jesusIsNot: "❌ Kolimbola ya ntina",
    clarification: "Kolimbola ya ntina",
    bibleOffline: "Kotánga Bible kozanga Internet",
    bibleStudy: "Koyekola Bible",
    version: "Version",
    openReader: "Kofungola motángi",
    features: "Biloko"
  },
  
  messages: {
    chooseCard: "⚡ Pona karte na yo ya nguya",
    cardHelp: "Ekozala na yo mpo na mituna 3 ya eteni oyo",
    chooseAnswer: "📖 Pona eyano na yo:",
    wrongAnswer: "❌ Eyano mabe! Ozali na bomoi {lives}. Meka lisusu!",
    levelCompleted: "Eteni {level} Esilami",
    questionsProgress: "Motuna {current} na 3",
    starsCollected: "Minzoto oyo osangisaki: {current}/{total}",
    pointsEarned: "+{points} Bapwana ya Bwanya",
    defeatedQuote: "Nakoki nyonso na Klisto oyo apesi ngai makasi",
    chapter: "Mokanda",
    chapterStars: "minzoto ya mokanda",
    totalGlobal: "Total mobimba",
    backToMenu: "Zonga na menu"
  },
  
  quotes: {
    wisdom: "Ebandeli ya bwanya ezali kobanga Nkolo",
    faith: "Nakoki nyonso na Klisto oyo apesi ngai makasi",
    hope: "Nkolo azali mobateli na ngai, nakozanga eloko te",
    love: "Zambe alingaki mokili mingi...",
    perseverance: "Kondima esengeli motema makasi",
    defeat: "Kozanga libongisi ezali malamu mpo na kokola na boyebi"
  },

  cards: {
    faith: "KONDIMA",
    courage: "MPIKO",
    wisdom: "BWANYA",
    faithKnowledge: "+50% ba points",
    courageKnowledge: "Libaku ya mibale",
    wisdomKnowledge: "Ndimbola + bonus",
    faithDesc: "Maximum ya ba points ya bwanya oyo ozwi",
    courageDesc: "Ba points ya normale kasi libaku ya mibale",
    wisdomDesc: "Ndimbola emonisami mpe +25% ba points",
    chooseCard: "✨ Pona makabo ya boyebi",
    cardEffects: "✨ Bopusi ya ba cartes ya boyebi:",
    faithEffect: "+50% ba points ya bwanya - Lifuti ya maximum",
    courageEffect: "Ba points ya normale kasi libaku ya mibale na libunga",
    wisdomEffect: "+25% ba points + ndimbola emonisami pona motuna nyonso",
    chooseWisely: "Pona na bwanya, pamba te kopona na yo ekosalisa yo na eteni mobimba"
  },

  challenge: {
    loading: "Ezali kotya eteni...",
    peace: "🕊️ Kimia ezala na ndako na yo",
    questionsAwaiting: "🎯 Mituna 3 ya boyebi ezali kozela yo",
    starsQuote: "Monzoto nyonso ezali litambwi moko na nzela ya pole ya Nzambe"
  },

  chapters: {
    "1": "Ebandeli",
    "2": "Kobima",
    "3": "Yesu-Klisto",
    "4": "Kobaka na Ekulusu/Kosekwa",
    "5": "Lingomba ya Ebandeli",
    "6": "Misala ya Paulo",
    "7": "Mikanda/Emoniseli",
    "8": "Eteni Bonus"
  },


  philosophy: {
    title: "Likambo ya filozofi",
    loveOntology: "Bolingo lokola moboko ya kozala",
    loveDescription: "Yesu abongoli bolingo lokola moboko ya kozala: kolinga Nzambe na baninga ezali ndenge ya kozala ya solo. Bolingo eleki malako mpe ekomi lolenge ya bomoi.",
    newCommandment: "Mibeko ya Sika",
    jesusEmphasizes: "Tango Yesu apesi mibeko ya sika, amonisi kozala ya kolinga",
    loveGod: "Linga Nzambe na motema na yo mobimba",
    loveNeighbor: "Linga ndeko na yo lokola yo moko",
    lovePriority: "Bolingo ekomi likambo ya liboso"
  },

  footer: {
    version: "Version 1.0 • 2024",
    dedication: "Esalemi mpo na nkembo ya Nzambe"
  },

  endCredits: {
    lines: [
      { text: "Okomi likolo ya ngomba", delay: 2000 },
      { text: "Oyekoli makambo mingi", delay: 2000 },
      { text: "Kondima na yo ezali kokola mokolo na mokolo", delay: 2000 },
      { text: "Ozali komona makambo kitoko na Nzambe", delay: 2000 },
      { text: "Mikakatano esalisaka yo kokola", delay: 2000 },
      { text: "Emonisaka nini ezali na ntina", delay: 2000 },
      { text: "Zala motema ya pamba lokola mwana moke", delay: 2000 },
      { text: "Nzambe alingaka motema na yo ya pamba", delay: 2000 },
      { text: "Na kimia oyokaka Nzambe", delay: 2000 },
      { text: "Kokila bilei epesaka molimo bonsomi", delay: 2000 },
      { text: "Sambela mpe Nzambe akotambwisa yo", delay: 2000 },
      { text: "Lolendo ebombaka bosolo", delay: 2000 },
      { text: "Ngolu ya Nzambe ezali monene", delay: 2000 },
      { text: "Euti na motema ya Nzambe", delay: 2000 },
      { text: "Kondima ya solo epesaka yo bonsomi", delay: 2000 },
      { text: "Ekosangisa yo na Nzambe libela na libela", delay: 2000 },
      { text: "Bolingo ekoki kobongola nyonso", delay: 2000 },
      { text: "Ekoki kosala bikamwa", delay: 2000 },
      { text: "Loba na ngai", delay: 2000 },
      { text: "Yesu, napesi yo motema na ngai", delay: 3000 },
      { text: "Ozali mokonzi na ngai, mobikisi na ngai", delay: 3000 },
      { text: "Yaka kobongola bomoi na ngai", delay: 3000 },
      { text: "Nzela ekobanda sik'oyo", delay: 2000 },
      { text: "Kabola pole kitoko oyo", delay: 2000 },
      { text: "Na bomoi oyo ekosila te", delay: 2000 },
      { text: "Bomba bolingo na motema na yo", delay: 3000 },
      { text: "Lokola bomengo ya ntalo", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "MATONDI!",
      proud: "TOZALI NA LOLENDO NA YO",
      courage: "MOBUNDI YA MPIKO",
      peace: "MEMI YA KIMIA",
      child: "MWANA YA NZAMBE",
      blessing: "NZAMBE APAMBOLA YO",
      continue: "Kobanda"
    }
  },

  mountain: {
    spiritualAscension: "Komata na molimo",
    levelProgress: "Nivo {{level}} • minzoto {{stars}} ezwami",
    combo: "Combo",
    perfectMessage: '"Pamba te makanisi na ngai ezali makanisi na bino te" - Mpate ezali komata epai ya bwanya ya kokoka',
    goodMessage: '"Boluka mpe bokozwa" - Komata epai ya solo ezali kokoba',
    startMessage: '"Kondima, ata soki ezali moke lokola mboto ya moutarde" - Litambe ya liboso epai ya pole',
    skipAnimation: "Koleka animation",
    chapter: "Mokanda",
    chapterProgress: "Mokanda {{current}}/{{total}}",
    secret: "Sekele",
    waypoints: {
      start: "Ebandeli",
      firstSlope: "Ngomba ya liboso",
      lastSlope: "Ngomba ya suka"
    },
    status: {
      defeat: "Kolonga te",
      inProgress: "Na mosala",
      victory: "Elonga"
    }
  },

  validation: {
    pseudoTooShort: "Nkombo ya mosaleli esengeli kozala na bileko 2 to koleka",
    enterPseudo: "Tia nkombo ya mosaleli"
  },

  pseudoSetup: {
    title: "Pona nkombo ya mosaleli",
    confirm: "Ndima Nkombo"
  },

  navigation: {
    back: "Zonga"
  },

  console: {
    starsUnlocked: "minzoto ekokisi! Fungola eteni",
    defeatAnimation: "Kolonga te... Y.K. akiti"
  },

  errors: {
    progressionError: "Libunga ya bokoli",
    invalidProgressionData: "Makambo ya bokoli ezali malamu te:"
  },

  levels: {
    chaptersAndBonus: "biteni 8 + eteni ya bonus",
    bonusUnlocked: "🏆 ETENI YA BONUS EFUNGWAMI! Okomi na bosengi ya molimo!",
    starsToDiscover: "273 {stars} ya komona",
    starsPerLevel: "3 {stars} mpo na eteni"
  },

  architecture: {
    title: "🔧 Botangi ya tekiniki",
    react: {
      name: "React",
      description: "Interface ya sika"
    },
    modules: {
      name: "Biteni",
      description: "Kotya ya dynamique"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Kobomba na esika"
    },
    tailwind: {
      name: "Tailwind",
      description: "Design responsive"
    }
  },

  gameManager: {
    title: "Kobomba masano",
    saveLocal: "Kobomba na esika",
    saveCloud: "Lipata esalemi",
    saveWaiting: "Kozela connexion",
    lastSave: "Kobomba ya suka:",
    never: "Ntango moko te",
    saving: "Kobomba...",
    save: "Bomba",
    loadProgress: "Zongisa",
    loading: "Kozongisa...",
    autoSaveEnabled: "💾 Kobomba ya automatique ezali",
    saveError: "❌ Libunga ya kobomba",
    gameSaved: "✅ Masano ebombami!",
    gameLoaded: "📥 Masano ezongisami!"
  },

  info: {
    title: "Masano ya Bondimi",
    subtitle: "Mobembo ya Molimo na kati ya Makomi",
    yourStats: "Ba stats na yo",
    score: "Mitindo",
    wisdom: "Bwanya",
    revelation: "Komonisama",
    createdWith: "Esalemi na",
    creator: "Emmanuel",
    developerPassionate: "Mosali programme oyo azali na mposa makasi mpe andimi, atii motema na mosala oyo.",
    artistModule: "Emmanuel Artiste",
    features: "Makambo ya malamu",
    multipleChapters: "📖 Ba mokandas mpe ba etenix ebele",
    powerCards: "🎴 Ba cartes ya nguya ya strategie",
    progressionSystem: "⭐ Ebongiseli ya bokoli oyo epesi mbano",
    bibleTreasures: "💎 Bomengo ya Bible pona kozwa",
    howToPlay: "Ndenge ya kosakana",
    selectLevel: "Pona eteni to mokanda",
    choosePowerCard: "Pona carte ya nguya",
    answerQuestions: "Yanola mituna",
    earnStars: "Zwa minzoto mpe tambola",
    tips: "Toli",
    readCarefully: "Tanga motuna nyonso malamu",
    useWisdomCard: "Salela carte ya bwanya pona ba indices",
    courageGivesSecondChance: "Mpiko epesi yo libaku ya mibale",
    faithMaximizes: "Bondimi ematisi minzoto na yo",
    johnGospelTitle: "Evangile ya Jean",
    johnGospelStats: "Bakapitulɛ 21 • Bavɛsɛ 878 • Maloba 14",
    bibleReaderStrong: "Motángi ya Bible + Strong",
    bibleReaderStrongDesc: "Motángi ya mobimba na diksionɛrɛ ya Strong",
    johnTreasures: "Bomengo ya Jean",
    johnTreasuresDesc: "Bomengo ya Bible mpe makambo ya ntina",
    quickAccessChapters: "Bokɔti nokinoki na bakapitulɛ oyo eyebani:",
    johnChapter1: "Ebandeli",
    johnChapter3: "Kobotama lisusu",
    johnChapter14: "Ngai nazali nzela",
    johnChapter20: "Lisekwa",
    version: "Version",
    madeWithLove: "Esalemi na bolingo mpe bondimi",
    backToMenu: "Zonga na menu"
  },

  bible: {
    readerTitle: "📖 Motángi ya Bible",
    johnReaderTitle: "Motángi ya Bible - Evangile ya Yoane",
    john: "Yoane",
    loading: "Ezali kotya Makomi ya Nzambe...",
    loadingChapter: "Mokanda {chapter} ya Evangile ya Yoane. Makambo nyonso ezali kotya...",
    exploreWhileLoading: "Na ntango oyo, okoki kotala mikanda mosusu to kosalela mosala ya boluki.",
    menu: "Menu",
    tabBible: "Bible",
    tabUnity: "Bomoko",
    strong: "Strong",
    strongReferences: "Batoli ya Strong",
    verses: "bavérité",
    previous: "Ya liboso",
    next: "Ya nsima",
    strongDefinition: "Ndimbola Strong",
    word: "Liloba ya ebandeli",
    transliteration: "Ndimbola ya makomi",
    close: "Kanga",
    share: "Kabola",
    shareVerse: "Kabola vérité oyo",
    shareSelection: "Kabola oyo oponaki",
    pronunciation: "Ndenge ya koloba",
    meaning: "Ntina",
    definition: "Ndimbola mobimba",
    usage: "Bosaleli na Bible",
    etymology: "Ebandeli ya liloba",
    search: "Koluka...",
    definitionNotFound: "Ndimbola ezwami te",
    definitionLoading: "Ndimbola ezali kotya...",
    imageFeatureComing: "🖼️ Bilili ekoya!",
    copyError: "Libunga ntango ya kokopya:",
    error: "❌ Libunga",
    errorLoading: "Libunga ya kotya",
    retry: "Meka lisusu",
    readerInDevelopment: "Motángi ya Bible ya Yoane ezali kotongama...",
    verseCopied: "Vérité ekopyami!",
    moreReferences: "mpe {{count}} batoli mosusu",
    copyright: "📖 LSG 1910 • Strong ekotami",
    markAsRead: "Eteni etángami",
    alreadyRead: "Etángami liboso",
    readingBonus: "Bonusi ya kotánga",
    results: "ndimbola",
    result: "ndimbola",
    copy: "Kokopisa",
    image: "Elilingi"
  },

  mountain: {
    chapter: "Mokanda",
    secret: "Sekele",
    spiritualAscension: "Komata ya Molimo",
    levelProgress: "Bokoli ya eteni",
    combo: "Combo",
    perfectMessage: "Malamu mpenza! 🌟",
    goodMessage: "Malamu mingi! ⭐",
    startMessage: "Banda! 🎯",
    skipAnimation: "Leka animation",
    stats: {
      points: "Ba points",
      level: "Eteni"
    },
    waypoints: {
      start: "Ebandeli",
      firstSlope: "Pente ya liboso",
      lastSlope: "Pente ya suka"
    },
    status: {
      victory: "Elonga",
      defeat: "Kokweya",
      inProgress: "Na progression"
    }
  },

  bibleResources: {
    inAppReader: {
      name: "Motángi na kati ya app",
      description: "Motángi ya Bible oyo ezali na makasi ya Strong",
      features: {
        offline: "✅ Mosala na Internet te",
        strong: "✅ Bandimbola Strong",
        navigation: "✅ Kotambola malamu"
      }
    }
  },

  quotes: {
    wisdom: "Bwanya ebandaka na kotosa Nzambe",
    faith: "Bondimi ezali kotyela motema na oyo tozali kozela",
    hope: "Elikya ezali ancre ya molimo",
    love: "Bolingo ezali monene koleka nyonso",
    perseverance: "Kopikola ebimisaka caractère",
    defeat: "Kotika te, pamba te kokweya nyonso ezali libaku ya kotelema makasi koleka"
  },

  philosophy: {
    title: "Philosophie",
    loveOntology: "Ontologie ya Bolingo",
    loveDescription: "Na motema ya bondimi ya Kristo, bolingo ezali kaka valeur morale te – ezali essence ya Nzambe ye moko.",
    newCommandment: "Mitindo ya sika napesi bino: Bolinga bino na bino. Ndenge nalingaki bino, bino mpe bolinga bino na bino.",
    jesusEmphasizes: "Yesu azali kolakisa ba aspects mibale ya bolingo:",
    loveGod: "Kolinga Nzambe na lolenge ya intime",
    loveNeighbor: "Kolinga moninga lokola yo moko",
    lovePriority: "Bolingo oyo ezali priorité absolue, oyo ezali likolo ya nyonso."
  },

  unity: unityTranslations,

  footer: {
    version: "Version 1.0",
    dedication: "Ebonzami na bato nyonso oyo bazali koluka solo mpe kimia"
  },

  endCredits: {
    lines: [
      { text: "🌟 Okomi na suka ya mobembo 🌟", delay: 0 },
      { text: "", delay: 2000 },
      { text: "Masano ya Bondimi", delay: 3000 },
      { text: "Mobembo ya Molimo na kati ya Makomi", delay: 4500 },
      { text: "", delay: 6000 },
      { text: "✨ Esalemi na ✨", delay: 7000 },
      { text: "❤️ Bolingo", delay: 8500 },
      { text: "🙏 Bondimi", delay: 10000 },
      { text: "💫 Elikya", delay: 11500 },
      { text: "", delay: 13000 },
      { text: "👨‍💻 Développement", delay: 14000 },
      { text: "Emmanuel", delay: 15500 },
      { text: "Mosali programme oyo azali na mposa makasi", delay: 17000 },
      { text: "", delay: 18500 },
      { text: "🎨 Design", delay: 19500 },
      { text: "React + Tailwind CSS", delay: 21000 },
      { text: "", delay: 22500 },
      { text: "📖 Contenu", delay: 23500 },
      { text: "Esalemi na makomi ya mosantu", delay: 25000 },
      { text: "", delay: 26500 },
      { text: "🙏 Matondo mingi", delay: 27500 },
      { text: "Na bato nyonso oyo basangani na mobembo oyo", delay: 29000 },
      { text: "", delay: 30500 },
      { text: "💝 Ebonzami", delay: 31500 },
      { text: "Na bato nyonso oyo bazali koluka solo", delay: 33000 },
      { text: "Mpe kimia na bomoi na bango", delay: 34500 },
      { text: "", delay: 36000 },
      { text: "✨ Matondo pona kosangana ✨", delay: 37000 },
      { text: "🌟 Mapamboli na litambwi nyonso 🌟", delay: 39000 }
    ],
    finalMessages: {
      congratulations: "Tóndisa yo pona kosilisa mobembo!",
      proud: "Okoki kozala na lofundu ya malamu na progression na yo.",
      courage: "Mpiko na yo ememaki yo tii awa.",
      peace: "Tika kimia ezala na litambwi na yo.",
      child: "Ozali mwana ya motuya ya Nzambe.",
      blessing: "Mapamboli na ngai ezali na yo.",
      continue: "Mobembo ekobanda..."
    }
  },

  validation: {
    pseudoTooShort: "Pseudo esengeli kozala na ba caractères 3 nsima",
    enterPseudo: "Tika okotisa pseudo"
  },

  pseudoSetup: {
    title: "Configuration ya profil",
    profileConfig: "Configuration ya profil na yo",
    connectedWith: "Connexion na:",
    playerPseudo: "Pseudo na yo ya player",
    pseudoPlaceholder: "Pona pseudo (3+ ba caractères)",
    pseudoRequirements: "Pseudo na yo ekomonana na masano",
    suggestions: "💡 Conseil: Pona nkombo oyo ekokundolisa yo mpe ba valeurs na yo",
    confirm: "Ndima",
    errorConfig: "Libunga na configuration ya profil"
  },

  navigation: {
    back: "Zonga"
  },

  console: {
    starsUnlocked: "Minzoto efungwami:",
    defeatAnimation: "Animation ya kokweya esalemi"
  },

  errors: {
    progressionError: "Libunga ya kotya progression",
    invalidProgressionData: "Makambo ya bokoli ezali malamu te"
  },

  levels: {
    chaptersAndBonus: "Ba mokandas mpe ba bonus",
    bonusUnlocked: "Bonus efungwami!",
    starsToDiscover: "Minzoto pona kozwa",
    starsPerLevel: "Minzoto na eteni"
  },

  architecture: {
    title: "Architecture",
    react: {
      name: "React",
      description: "Bibliothèque UI moderne pona interface interactive"
    },
    modules: {
      name: "Modules ES6",
      description: "Code organisé mpe maintenable"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Kobomba progression ya locale"
    },
    tailwind: {
      name: "Tailwind CSS",
      description: "Design rapide mpe personnalisable"
    }
  },

  gameManager: {
    title: "Gestion ya masano",
    saveLocal: "Kobomba na esika",
    saveCloud: "Kobomba na lipata",
    saveWaiting: "Kobomba ezali kozela...",
    lastSave: "Kobomba ya suka:",
    never: "Ntango moko te",
    saving: "Kobomba...",
    save: "Bomba",
    loadProgress: "Zongisa",
    loading: "Kozongisa...",
    autoSaveEnabled: "💾 Kobomba ya automatique ezali",
    saveError: "❌ Libunga ya kobomba",
    gameSaved: "✅ Masano ebombami!",
    gameLoaded: "📥 Masano ezongisami!"
  }
};

export default uiTranslations;
